export enum ContentCueTrackEvent {
	ACTIVE_CUES_CHANGED = 'activeCuesChanged'
}
